import React, { useCallback, useEffect, useState } from "react";

import { getAdminUser, updateUser } from "services";

import { incomplete, useCancelAsyncOnUnmount, useNavigate, useParams } from "utils";

import { adminRoles } from "enums";

import { AdminHead, AdminRolesDrawer, Button, Col, Form, Input, Link, MainPage, Option, Row, Select, Message as message } from "components";

export const AdminUserUpdate = () => {
  const { id } = useParams();

  const [loading, setLoading] = useState(true);
  const [user, setUser] = useState(false);
  const [showDrawer, setShowDrawer] = useState(false);
  const signal = useCancelAsyncOnUnmount()();
  const navigate = useNavigate();

  const loadUser = useCallback(() => {
    setLoading(true);

    getAdminUser({
      id: id,
      signal,
    })
      .then((res) => {
        setUser(res);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [id, signal]);

  const complete = (v) => {
    setLoading(true);

    updateUser({
      ...v,
      ...{ id: id, signal },
    })
      .then(() => {
        navigate("/settings");
        message({
          content: "The gremlins accepted your sacrifice and will consume it! Nom nom nom",
          icon: "gremlin",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    loadUser();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <MainPage loading={loading} pageName={"admin"}>
      <AdminHead
        headline="Update an admin user"
        link="/settings/users"
        tooltipText="Back to admin users"
        description={
          <>
            Update an admin user here - you will set their access level and password, which they can changed later.{" "}
            <Link tracking={false} onClick={() => setShowDrawer(true)}>
              View admin role details
            </Link>
            .
          </>
        }
      />
      <Row className="midi-form">
        <Col>
          <Form name="confirm" onFinish={(v) => complete(v)} onFinishFailed={(v) => incomplete(v)}>
            <Row>
              <Col sm={12} md={12}>
                <Input name="firstName" label="First name" rules={[{ required: true }]} initialValue={user.firstName} />
              </Col>
              <Col sm={12} md={12}>
                <Input name="lastName" label="Last name" rules={[{ required: true }]} initialValue={user.lastName} />
              </Col>
            </Row>
            <Row>
              <Col sm={12} md={12}>
                <Input name="email" label="Email address" rules={[{ required: true, type: "email" }]} initialValue={user.email} />
              </Col>
              <Col sm={6} md={6}>
                <Select name="role" label="User role" rules={[{ required: true }]} initialValue={user.role}>
                  {adminRoles.map((role, i) => (
                    <Option value={role.role} key={i}>
                      {role.label ?? role.role}
                    </Option>
                  ))}
                </Select>
              </Col>
            </Row>
            <Row>
              <Col sm={6} md={12}>
                <Select name="status" label="Status" rules={[{ required: true }]} initialValue={user.confirmed}>
                  <Option value={true}>Enabled</Option>
                  <Option value={false}>Disabled</Option>
                </Select>
              </Col>
              <Col sm={6} md={12}>
                <Select name="verifier" label="Is verifier" rules={[{ required: false }]} initialValue={user.verifier}>
                  <Option value={true}>yup</Option>
                  <Option value={false}>nope</Option>
                </Select>
              </Col>
            </Row>
            <Row>
              <Col>
                <Form.Item>
                  <Button type="primary" htmlType="submit" disabled={loading} loading={loading}>
                    Save
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
      <AdminRolesDrawer visible={showDrawer} onClose={() => setShowDrawer(false)} />
    </MainPage>
  );
};
